<template>
  <div class="d-flex flex-row">
    <div class="mr-12 d-flex flex-column align-center">
      <Subtitle custom-class="mb-1">Schritt 1:</Subtitle>
      <img style="max-width: 256px" :src="step1" />
    </div>
    <div class="d-flex flex-column align-center">
      <Subtitle custom-class="mb-1">Schritt 2:</Subtitle>
      <img style="max-width: 256px" :src="step2" />
    </div>
    <div class="ml-12 d-flex flex-column align-center">
      <Subtitle custom-class="mb-1">Schritt 3:</Subtitle>
      <img style="max-width: 256px" :src="step3" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import Subtitle from "components/UI/Subtitle.vue"

export default defineComponent({
  name: "ScreenStepsRow",
  components: { Subtitle },
  props: {
    step1: {
      type: String,
      required: true,
    },
    step2: {
      type: String,
      required: true,
    },
    step3: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    return {}
  },
})
</script>
